// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lI4nh","left":"styles_left__2nlPN","desktopActions":"styles_desktopActions__2Kj8O","title":"styles_title__e9VJC"};